import { render, staticRenderFns } from "./Graph3D.vue?vue&type=template&id=96c80fb6&scoped=true&"
import script from "./Graph3D.vue?vue&type=script&lang=js&"
export * from "./Graph3D.vue?vue&type=script&lang=js&"
import style0 from "./Graph3D.vue?vue&type=style&index=0&id=96c80fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c80fb6",
  null
  
)

export default component.exports